module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "epi"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "epiv"
  }, [_vm._v("“With love and care the spiderweb weaves its spider.”")]), _vm._v(" "), _c('div', {
    staticClass: "eps"
  }, [_vm._v("—UNKNOWN AFRICAN ORIGIN")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe360310","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/henn_9781595586124_oeb_epi_r1.vue
// module id = 69
// module chunks = 0